import { Injectable } from '@angular/core';
import { Color, MultiplyBlending, NormalBlending } from 'three';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';

@Injectable({
  providedIn: 'root'
})
export class MaterialsModel {
  public static readonly CONTOUR_COLOR: number = 0x000000;
  public static readonly CONTOUR_COLOR_GREY: number = 0x707070;
  public static readonly CONTOUR_COLOR_TRANSPARENT: number = 0xaaaaaa;
  public static readonly SELECTION_COLOR: number = 0x03c03c;

  private _materialContour = new LineMaterial({color: MaterialsModel.CONTOUR_COLOR, linewidth: 1.1});
  private _materialContourGrey = new LineMaterial({color: MaterialsModel.CONTOUR_COLOR_GREY, linewidth: 1.1});
  private _materialContourDrillingHole = new LineMaterial({color: 0xffffff, linewidth: 1.1});
  private _materialContourInvalid = new LineMaterial({color: 0xff0000, linewidth: 1.1});
  private _materialContourSelection = new LineMaterial({color: MaterialsModel.SELECTION_COLOR, linewidth: 3});

  /** when called with true, causes materialContourSelection to be rendered on top of articles */
  public setOntopSelectionMaterial(renderOntop: boolean) {
    this._materialContourSelection.depthTest = !renderOntop;
    this._materialContourSelection.depthWrite = !renderOntop;
    this._materialContourSelection.transparent = renderOntop;
    this._materialContourSelection.needsUpdate = true;
    this._materialContour.blending = renderOntop ? MultiplyBlending : NormalBlending;
    this._materialContour.color = new Color(renderOntop ?
      MaterialsModel.CONTOUR_COLOR_TRANSPARENT
      : MaterialsModel.CONTOUR_COLOR
    );

    this._materialContourGrey.blending = renderOntop ? MultiplyBlending : NormalBlending;
    this._materialContourGrey.color = new Color(renderOntop ?
      MaterialsModel.CONTOUR_COLOR_TRANSPARENT
      : MaterialsModel.CONTOUR_COLOR_GREY
    );
  }

  public setTransparent(transparent: boolean): void {
    this._materialContour.color = new Color(transparent ?
      MaterialsModel.CONTOUR_COLOR_TRANSPARENT
      : MaterialsModel.CONTOUR_COLOR
    );

    this._materialContourGrey.color = new Color(transparent ?
      MaterialsModel.CONTOUR_COLOR_TRANSPARENT
      : MaterialsModel.CONTOUR_COLOR_GREY
    );
  }

  public get materialContourSelection(): LineMaterial {
    return this._materialContourSelection;
  }
  public get materialContourInvalid(): LineMaterial {
    return this._materialContourInvalid;
  }
  public get materialContourDrillingHole(): LineMaterial {
    return this._materialContourDrillingHole;
  }
  public get materialContour(): LineMaterial {
    return this._materialContour;
  }
  public get materialContourGrey(): LineMaterial {
    return this._materialContourGrey;
  }
}
